/**
 * mv
 */

import { functions } from "../../modules/functions"
import { Offset } from "../../modules/offset";

export module MvModule {
  const EaseFunction = {
    linear: (t: number) => t,
    easeInOut: (t: number) => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuad: (t: number) => t * t,
    easeOutQuad: (t: number) => t * (2 - t),
    easeInOutQuad: (t: number) => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: (t: number) => t * t * t,
    easeOutCubic: (t: number) => (--t) * t * t + 1,
    easeInOutCubic: (t: number) => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuart: (t: number) => t * t * t * t,
    easeOutQuart: (t: number) => 1 - (--t) * t * t * t,
    easeInOutQuart: (t: number) => t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t,
    easeInQuint: (t: number) => t * t * t * t * t,
    easeOutQuint: (t: number) => 1 + (--t) * t * t * t * t,
    easeInOutQuint: (t: number) => 1 + (--t) * t * t * t * t,
    easeInElastic: (t: number) => (.04 - .04 / t) * Math.sin(25 * t) + 1,
    easeOutElastic: (t: number) => .04 * t / (--t) * Math.sin(25 * t),
    easeInOutElastic: (t: number) => (t -= .5) < 0 ? (.01 + .01 / t) * Math.sin(50 * t) : (.02 - .01 / t) * Math.sin(50 * t) + 1,
  }

  export class Service {
    private static $startOpacity = 0.75;
    private static $maxOpacity = 0.45;
    private static $ratio = (Service.$maxOpacity - Service.$startOpacity) / 100;
    private static $speed = 1000
    private static EASE = EaseFunction
    private static $pageYStart = 0
    private static $pageYMove = 0
    private static $bodyElement = Service.getBody()

    constructor() {
      //if (window.performance) {
      //  if (window.performance.navigation.type === 1) {
      //    Service.scrolltop();
      //  }
      //}

      //window.addEventListener('pageshow', function ($event) {
      //  if ($event.persisted) {
      //    Service.scrolltop();
      //    window.location.reload();
      //  }
      //});

      //document.addEventListener('loadCompleteAction', () => {
      //  Service.scrolltop();
      //}, false)

      document.addEventListener('readCompleteAction', () => {
        //Service.scrolltop();
        document.addEventListener('touchmove', Service.noscroll, { passive: false });
        document.addEventListener('wheel', Service.noscroll, { passive: false });
        Service.setEvent();
      }, false)
    }

    private static setEvent() {
      const $mvBackground = document.querySelector<HTMLElement>('.mv__background')
      const $mainWrapBackground = document.querySelector<HTMLElement>('.mainWrap__background')
      const $mv = document.querySelector<HTMLElement>('.mv')

      if ($mvBackground && $mainWrapBackground && $mv) {
        functions.addEventListenerMultiType(document, 'scroll touchmove', () => {
          Service.mvBackgroundScrollAction()
          Service.mainWrapBackgroundScrollAction()
        }, true)

        const $bodyElement = Service.getBody()
        const $scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        const $mv = document.querySelector<HTMLElement>('.mv')
        const $mvCatchCopy = document.querySelector<HTMLElement>('.mv__catchCopy')
        if ($mvCatchCopy && $bodyElement && $mv) {
          const $breakpoint = $mv.clientHeight
          if ($scrollTop >= $breakpoint) {
            $bodyElement.classList.add('js__onScroll')
            $bodyElement.classList.remove('js__mvWheelAction')
            $mv.classList.add('isDisplayOut')
          }
        }

        document.addEventListener('wheel', ($event: WheelEvent) => {
          Service.wheelAction($event)
        }, { passive: false });
        window.addEventListener('touchstart', ($event: TouchEvent) => {
          Service.touchstartAction($event)
        }, { passive: false });
        window.addEventListener('touchmove', ($event: TouchEvent) => {
          Service.touchmoveAction($event)
        }, { passive: false });
        window.addEventListener('touchend', ($event: TouchEvent) => {
          Service.touchendAction($event)
        }, { passive: false });
        document.addEventListener('scroll', ($event: Event) => {
          Service.mvDisplayOutScrollAction($event)
        }, { passive: false });
        window.addEventListener('touchmove', ($event: Event) => {
          Service.mvDisplayOutScrollAction($event)
        }, { passive: false });
      }
    }

    private static mvDisplayOutScrollAction($event: Event) {
      const $bodyElement = Service.getBody()
      const $scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const $mv = document.querySelector<HTMLElement>('.mv')
      const $mvCatchCopy = document.querySelector<HTMLElement>('.mv__catchCopy')

      if ($mvCatchCopy && $bodyElement && $bodyElement.classList.contains('js__onScroll') && $mv?.classList.contains('isDisplayOut') && !$bodyElement.classList.contains('js__mvWheelAction')) {
        const $breakpoint = $mv.clientHeight
        if ($scrollTop <= $breakpoint) {
          $event.preventDefault()
          $bodyElement.classList.remove('js__onScroll')
          Service.smoothScroll($mvCatchCopy)
          $bodyElement.classList.add('js__mvWheelAction')
          setTimeout(() => {
            $bodyElement.classList.remove('js__mvWheelAction')
            $mv.classList.remove('isDisplayOut')
          }, Service.$speed);
        }
      }

      if ($mv && $mv.clientHeight < $scrollTop + 10 && $bodyElement && !$bodyElement.classList.contains('js__onScroll')) {
        $bodyElement.classList.add('js__onScroll')
      }
    }

    private static wheelAction($event: WheelEvent) {
      const $deltaY = $event.deltaY
      if ($deltaY < 5 && $deltaY > -5) {
      } else {
        Service.wheelTouchAction($event as Event, $deltaY)
      }
    }

    private static touchstartAction($event: TouchEvent) {
      Service.$pageYStart = $event.touches[0].pageY
    }

    private static touchmoveAction($event: TouchEvent) {
      Service.$pageYMove = $event.changedTouches[0].pageY
    }

    private static touchendAction($event: TouchEvent) {
      Service.wheelTouchAction($event as Event, (Service.$pageYStart - Service.$pageYMove))
    }

    private static wheelTouchAction($event: Event, $scrollAmount: number) {
      const $bodyElement = Service.getBody()
      const $mv = document.querySelector<HTMLElement>('.mv');
      const $mvCatchCopy = $mv?.querySelector('.mv__catchCopy')
      const $mainContent = document.querySelector('#mainContent')

      if ($bodyElement && $mainContent && $mv && $mvCatchCopy && $scrollAmount && !$bodyElement.classList.contains('js__mvWheelAction')) {
        if (!$mv.classList.contains('isDisplayOut')) {
          $event.preventDefault()
          if ($scrollAmount > 5) {
            // down
            if ($mv.classList.contains('isCatchCopy')) {
              Service.smoothScroll($mainContent)
              $bodyElement.classList.add('js__mvWheelAction')
              setTimeout(() => {
                $bodyElement.classList.remove('js__mvWheelAction')
              }, Service.$speed)
              setTimeout(() => {
                $mv.classList.add('isDisplayOut')
                $bodyElement.classList.add('js__onScroll')
              }, Service.$speed + 100)
            } else {
              Service.smoothScroll($mvCatchCopy)
              $bodyElement.classList.add('js__mvWheelAction')
              $mv.classList.add('isCatchCopy')
              setTimeout(() => {
                $bodyElement.classList.remove('js__mvWheelAction')
              }, Service.$speed);
            }
          } else if ($scrollAmount < -5) {
            // up
            if ($mv.classList.contains('isCatchCopy')) {
              Service.smoothScroll($bodyElement)
              $bodyElement.classList.add('js__mvWheelAction')
              $mv.classList.remove('isCatchCopy')
              setTimeout(() => {
                if ($bodyElement.classList.contains('js__mvWheelAction')) {
                  $bodyElement.classList.remove('js__mvWheelAction')
                }
              }, Service.$speed);
            }
          }
        }
      }
    }

    private static smoothScroll($targetElement: HTMLElement | Element) {
      let $currentPostion: number = Service.getBody()?.scrollTop ?? 0
      let $targetPosition: number
      let $startTime: number

      if ($targetElement) {
        $startTime = performance.now();
        $targetPosition = Offset.getTop($targetElement) + 1;

        let loopFunction = function ($nowTime: number) {
          let $time = $nowTime - $startTime;
          let $normalizedTime = $time / Service.$speed;
          if ($normalizedTime < 1) {
            window.scrollTo(0, $currentPostion + (($targetPosition - $currentPostion) * Service.EASE.easeInOut($normalizedTime)));
            requestAnimationFrame(loopFunction);
          } else {
            window.scrollTo(0, $targetPosition);
          }
        }

        requestAnimationFrame(loopFunction);
      }
    }

    private static mvBackgroundScrollAction() {
      const $mvBackground = document.querySelector<HTMLElement>('.mv__background');
      if ($mvBackground) {
        const $scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const $windowHeight = window.innerHeight;

        if ($scrollTop >= $windowHeight) {
          $mvBackground.style.opacity = String(Service.$maxOpacity);
        } else if ($scrollTop <= 0) {
          $mvBackground.style.opacity = String(Service.$startOpacity);
        } else {
          $mvBackground.style.opacity = String(Service.$startOpacity + (Service.$ratio * ($scrollTop / $windowHeight * 100)));
        }
      }
    }

    private static mainWrapBackgroundScrollAction() {
      const $mainWrapBackground = document.querySelector<HTMLElement>('.mainWrap__background');
      const $mv = document.querySelector<HTMLElement>('.mv');
      if ($mainWrapBackground && $mv) {
        const $scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        if ($scrollTop > $mv.clientHeight) {
          $mainWrapBackground.style.opacity = String(0);
          $mv.style.opacity = String(0);
        } else if ($scrollTop <= ($mv.clientHeight / 2)) {
          $mainWrapBackground.style.opacity = String(1);
          $mv.style.opacity = String(1);
        } else {
          $mainWrapBackground.style.opacity = String(1 - (0.01 * (($scrollTop - ($mv.clientHeight / 2)) / ($mv.clientHeight / 2) * 100)));
          $mv.style.opacity = String(1 - (0.01 * (($scrollTop - ($mv.clientHeight / 2)) / ($mv.clientHeight / 2) * 100)));
        }
      }
    }

    private static getBody() {
      if ('scrollingElement' in document) {
        return document.scrollingElement;
      }
      // Fallback for legacy browsers
      if (navigator.userAgent.indexOf('WebKit') != -1) {
        return document.body;
      }
      return document.documentElement;
    }

    private static noscroll($event: Event) {
      if (!Service.$bodyElement || !Service.$bodyElement.classList.contains('js__onScroll')) {
        $event.preventDefault();
      }
    }

    private static scrolltop($event: Event | null = null) {
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0;
      } else {
        document.body.scrollTop = 0;
      }
      window.scroll(0, 0);
    }

  }
}
